import React from 'react';
import {
  Box,
  Typography,
  Chip,
  Paper,
  List,
  ListItem,
  ListItemText,
  Divider
} from '@mui/material';
import { Assignment, CalendarToday } from '@mui/icons-material';

const GoalsCard = ({ goalsData }: any) => {
  
  if (!Array.isArray(goalsData) || goalsData.length === 0) {
    return (
      <Typography variant="body2" sx={{ p: 2, textAlign: 'center', color: 'gray' }}>
        No data available to display.
      </Typography>
    );
  }

  const formatEndDate = (dateString: string) => {
    if (!dateString) return 'N/A';
    try {
      return new Date(dateString).toLocaleDateString();
    } catch {
      return dateString;
    }
  };

  return (
    <Box sx={{ paddingX: 2, marginTop: 2 }}>
      {goalsData.map((goal: any, index: number) => {
        const objective = typeof goal?.objective === 'string' ? goal.objective : 'N/A';
        const score = goal?.score !== undefined && goal.score !== null ? goal.score : 'N/A';
        const relatedParams = Array.isArray(goal?.relatedParams) ? goal.relatedParams : [];

        return (
          <Paper 
            key={`goal-${index}`} 
            elevation={1}
            sx={{ 
              mb: 1, 
              border: '1px solid #e0e0e0'
            }}
          >
            {/* Objective Header */}
            <Box sx={{ 
              p: 2, 
              backgroundColor: 'grey.300',
              color: 'black',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                <Assignment sx={{ mr: 1, fontSize: 20 }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                  {objective}
                </Typography>
              </Box>
              <Chip 
                label={`${score}%`}
                sx={{ 
                  backgroundColor: 'white',
                  color: 'grey.700',
                  fontWeight: 600
                }}
              />
            </Box>

            {/* Key Results */}
            <Box sx={{ p: 0 }}>
              {relatedParams.length === 0 ? (
                <Box sx={{ p: 2 }}>
                  <Typography variant="body2" sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
                    No Key Results defined
                  </Typography>
                </Box>
              ) : (
                <List sx={{ py: 0 }}>
                  {relatedParams.map((param: any, paramIndex: number) => {
                    const keyResult = typeof param?.keyResult === 'string' ? param.keyResult : 'N/A';
                    const endDate = formatEndDate(param?.endDate);

                    return (
                      <React.Fragment key={`param-${paramIndex}`}>
                        <ListItem sx={{ py: 1.5, px: 2 }}>
                          <Assignment sx={{ mr: 1, color: 'text.secondary', fontSize: 18 }} />
                          <ListItemText 
                            primary={keyResult}
                            sx={{ mr: 2 }}
                          />
                          <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 'fit-content' }}>
                            <CalendarToday sx={{ mr: 0.5, fontSize: 14, color: 'text.secondary' }} />
                            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                              {endDate}
                            </Typography>
                          </Box>
                        </ListItem>
                        {paramIndex < relatedParams.length - 1 && <Divider />}
                      </React.Fragment>
                    );
                  })}
                </List>
              )}
            </Box>
          </Paper>
        );
      })}
    </Box>
  );
};

export default GoalsCard;